jQuery(document).ready(function ($) {


    // Find all labels inside the fieldset
    $(".swatchh .product-form__input label p").each(function() {
        // Check if the label text exactly matches "Twin"
        if ($(this).text().trim() === "Twin") {
            // Append the span with the specified text
            $(this).append('<span>38" x 75"</span>');
        } else if ($(this).text().trim() === "Twin XL") {
            // Append the span with the specified text for "Twin XL"
            $(this).append('<span>38" x 80"</span>');
        } else if ($(this).text().trim() === "Full") {
            // Append the span with the specified text for "Full"
            $(this).append('<span>54" x 75"</span>');
        } else if ($(this).text().trim() === "Queen") {
            // Append the span with the specified text for "Queen"
            $(this).append('<span>60" x 80"</span>');
        } else if ($(this).text().trim() === "King") {
            // Append the span with the specified text for "King"
            $(this).append('<span>76" x 80"</span>');
        } else if ($(this).text().trim() === "California King") {
            // Append the span with the specified text for "California King"
            $(this).append('<span>72" x 84"</span>');
        } else if ($(this).text().trim() === "Cal King") {
            // Append the span with the specified text for "California King"
            $(this).append('<span>72" x 84"</span>');
        }
    });
        
    $('.moreless-button').click(function() {
	  $('.product__description.rte').toggleClass('ellipses');
	  if ($('.moreless-button').text() == "Read More About Product") {
		$(this).text("Read Less")
	  } else {
		$(this).text("Read More About Product")
	  }
	});

    $('.benefits .section_heading').click(function(){
      $(this).toggleClass('active');
      $(this).next('.benefit-list').toggleClass('active');
    });
        
});

window.ac = window.ac || {}
  ac.chatLink = document.querySelector("a[href='#chat']");

  if (ac.chatLink) {
    ac.chatLink.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      chat = document.getElementById("ShopifyChat");
      iframeId = chat ? "ShopifyChat" : "dummy-chat-button-iframe";
      document.getElementById(`${iframeId}`).shadowRoot.querySelector("button.chat-toggle").click();
    });
  }